import request from '@/utils/request'
import { hashPasswordSync } from '@/utils/common'

// CSRF token
export function csrfToken() {
  return request.get('/clients/web/csrf/token')
}

// 获取全局配置
export function getGlobalConfig() {
  return request.get('/clients/web/global/config?type=download_url')
}

// 用户登录
export function login(params) {
  return hashPasswordSync(params.password).then(password => {
    return request.post('/clients/web/auth/login', { ...params, password })
  })
}

// 用户注册
export function register(params) {
  return hashPasswordSync(params.password).then(password => {
    return request.post('/clients/web/auth/register', { ...params, password })
  })
}

// 发送注册验证码
export function registerCode(email, captcha) {
  return request.post('/clients/web/auth/register/code', { email, captcha })
}

// 获取用户信息
export function getUserInfo() {
  return request.get('/clients/web/auth/profile')
}

// 用户登出
export function logout() {
  return request.get('/clients/web/auth/logout')
}

// 更新密码
export async function updatePassword(currentPassword, newPassword) {
  const cp = await hashPasswordSync(currentPassword)
  return request.post('/clients/web/auth/password/change', { currentPassword: cp, newPassword })
}

// 发送重置密码链接
export function sendResetPasswordLink(params) {
  return request.post('/clients/web/auth/reset-password/link', params)
}

// 重置密码
export async function resetPassword(params) {
  const hashedPassword = await hashPasswordSync(params.newPassword)
  return request.post('/clients/web/auth/reset-password', { token: params.token, password: hashedPassword })
}

// 发送邮箱验证码
export function sendEmailCode(email) {
  return request.post('/clients/web/auth/send-change-email-code', { email })
}

// 更新邮箱
export function updateEmail(email, code) {
  return request.post('/clients/web/auth/change-email', { email, code })
}